import {
  OpenCommentThread,
  RemovedCommentThread,
  ResolvedCommentThread,
} from './CommentThread';
import {
  AcceptedSuggestionThread,
  DeclinedSuggestionThread,
} from './SuggestionThread';

interface CommentThreadListProps {
  threads: CommentsRepository.CommentThreadFetched[];
  isMultiroot?: boolean;
}

export const CommentThreadList = ({
  threads,
  isMultiroot,
}: CommentThreadListProps) => {
  return (
    <>
      {threads?.map(
        (commentThread: CommentsRepository.CommentThreadFetched) => {
          switch (commentThread.status) {
            case 'Open':
              return (
                <OpenCommentThread
                  thread={commentThread}
                  key={commentThread.id}
                />
              );
            case 'Resolved':
              return (
                <ResolvedCommentThread
                  thread={commentThread}
                  key={commentThread.id}
                  isMultiroot={isMultiroot}
                />
              );
            case 'Removed':
              return (
                <RemovedCommentThread
                  thread={commentThread}
                  key={commentThread.id}
                />
              );
            case 'Accepted':
              return (
                <AcceptedSuggestionThread
                  thread={commentThread}
                  key={commentThread.id}
                />
              );
            case 'Rejected':
              return (
                <DeclinedSuggestionThread
                  thread={commentThread}
                  key={commentThread.id}
                />
              );
            default:
              return <></>;
          }
        },
      )}
    </>
  );
};
